import { useState, useRef, useEffect, type ReactNode } from 'react'

interface HelpIconProps {
  text: string
  children?: ReactNode
}

export function HelpIcon({ text, children }: HelpIconProps) {
  const [open, setOpen] = useState(false)
  const triggerRef = useRef<HTMLButtonElement>(null)
  const panelRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (!open) return

    function handleClickOutside(e: MouseEvent) {
      if (
        panelRef.current && !panelRef.current.contains(e.target as Node) &&
        triggerRef.current && !triggerRef.current.contains(e.target as Node)
      ) {
        setOpen(false)
      }
    }

    function handleEscape(e: KeyboardEvent) {
      if (e.key === 'Escape') setOpen(false)
    }

    document.addEventListener('mousedown', handleClickOutside)
    document.addEventListener('keydown', handleEscape)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
      document.removeEventListener('keydown', handleEscape)
    }
  }, [open])

  if (children) {
    return (
      <span className="help-icon help-icon--inline">
        {children}
        <button
          ref={triggerRef}
          type="button"
          className="help-icon__trigger"
          aria-label="More information"
          onMouseEnter={() => setOpen(true)}
          onMouseLeave={() => setOpen(false)}
          onFocus={() => setOpen(true)}
          onClick={() => setOpen(!open)}
        >
          ?
        </button>
        {open && (
          <div
            ref={panelRef}
            className="help-icon__panel"
            role="tooltip"
          >
            {text}
          </div>
        )}
      </span>
    )
  }

  return (
    <span className="help-icon">
      <button
        ref={triggerRef}
        type="button"
        className="help-icon__trigger"
        aria-label="More information"
        onMouseEnter={() => setOpen(true)}
        onMouseLeave={() => setOpen(false)}
        onFocus={() => setOpen(true)}
        onClick={() => setOpen(!open)}
      >
        ?
      </button>
      {open && (
        <div
          ref={panelRef}
          className="help-icon__panel"
          role="tooltip"
        >
          {text}
        </div>
      )}
    </span>
  )
}
